import React from 'react';
import styled from 'styled-components';
import { Menu as MenuAntd } from 'antd';
import { MenuInfo } from 'rc-menu/lib/interface';

export interface MenuItem {
  id: string;
  label: string;
  icon: string;
}

export interface MenuProp {
  items: MenuItem[];
  selectedItemKey: string;
  menuStyles: React.CSSProperties;
  menuItemStyles: React.CSSProperties;
  onItemClick: (props: MenuInfo) => void;
}

const StyledMenu = styled(MenuAntd)`
  &::before {
    content: none;
  }

  &::after {
    content: none;
  }
`;

const Menu = ({ items, selectedItemKey, menuStyles, menuItemStyles, onItemClick }: MenuProp) => (
  <StyledMenu
    mode="horizontal"
    inlineIndent={0}
    selectedKeys={[selectedItemKey]}
    onClick={(info) => onItemClick(info)}
    style={menuStyles}
  >
    {items.map((item) => (
      <StyledMenu.Item key={item.id} icon={<img src={item.icon} alt={item.label} />} style={menuItemStyles}>
        {item.label}
      </StyledMenu.Item>
    ))}
  </StyledMenu>
);

export default Menu;
